// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__1J4Eb","heading":"PrivacyPolicy_heading__3Jx89","content":"PrivacyPolicy_content__3V6M_"};